import { ACTION_TYPES } from '~/core/constants'

const { EVENTS, CALENDAR } = ACTION_TYPES
const initialState = {
  fetchingInProgress: false,
  eventsFetched: false,
  items: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS.FETCHING_IN_PROGRESS: {
      return {
        ...state,
        fetchingInProgress: action.payload
      }
    }
    case EVENTS.FETCHED_EVENTS: {
      return {
        ...state,
        fetchingInProgress: false,
        eventsFetched: true,
        items: action.payload
      }
    }
    case EVENTS.UPDATE_EVENT: {
      const { payload: event } = action

      return {
        ...state,
        items: state.items.map(item => {
          if (item.eventId === event.eventId) {
            return event
          }

          return item
        })
      }
    }
    case CALENDAR.PURGE_CALENDAR_DATA: {
      return initialState
    }
    default:
      return state
  }
}

export default reducer
